import { convertObjectKeysCase } from '@frontend/duck-tape';
import { initGrowthBook, type GrowthBook } from '@frontend/react/growthbook';
import type { FeatureMap } from '@frontend/react/hooks/growthbook/helpers';
import { initCio } from '@frontend/web-utils/cio';
import { getSegment, initSegment } from '@frontend/web-utils/segment';
import { initSentry, initVitePreloadErrorHandler } from '@frontend/web-utils/sentry';
import { Env } from './env';
import { logLoadPerf } from './logLoadPerf';

// eslint-disable-next-line fp/no-let
let growthbook: GrowthBook<FeatureMap>;

// eslint-disable-next-line fp/no-let
let wasInitExecuted = false;

// Technically this function should be made asynchronous because of Growthbook, but we don't run into race conditions
// when using it in the Growthbook context wrapper
export const initApp = () => {
  if (wasInitExecuted) {
    return { growthbook };
  }

  logLoadPerf('Main bundle: initApp start');
  initSentry({ dsn: Env.VITE_SENTRY_DSN, env: Env.VITE_ENV });
  initVitePreloadErrorHandler({ env: Env.VITE_ENV });
  initSegment({ writeKey: Env.VITE_SEGMENT_WRITE_KEY });
  initCio({ window });
  logLoadPerf('Analytics: Segment initialized');

  // eslint-disable-next-line fp/no-mutation
  growthbook = initGrowthBook({
    autoInit: true,
    clientKey: Env.VITE_GROWTHBOOK_CLIENT_KEY,
    env: Env.VITE_ENV,
    trackingCallback: async (experiment, result) => {
      getSegment()?.track(
        'Experiment Viewed',
        convertObjectKeysCase(
          {
            experimentId: experiment.key,
            variationId: result.variationId,
          },
          'snakeCase',
        ),
      );
    },
  });

  // eslint-disable-next-line fp/no-mutation
  wasInitExecuted = true;
  return { growthbook };
};
